import React from 'react';
import type { ContactClient } from '@hero/schema';
import { useClientDrawerStore } from '@hero/hooks-shared';
import { BuildingIcon } from '@hero/web-icons';
import { Card } from '../../../app/Card/Card';
import { ClientRolesBadge } from '../../Client/Status/ClientRolesBadge';

export interface ContactClientCardProps {
  /**
   * Embedded `Contact.clients[]` entry. `_id` references a `Client._id`
   * (the unified relations-v2 CRM entity). `roles[]` carries the full
   * multi-role snapshot of the linked Client.
   */
  client: ContactClient;
  className?: string;
}

/**
 * Card rendered inside a `Contact` drawer to show the unified `Client`
 * this contact is linked to. Tapping the card opens the `ClientDrawer`.
 */
export const ContactClientCard: React.FC<ContactClientCardProps> = ({ client, className }) => {
  const openDrawer = useClientDrawerStore(s => s.open);

  return (
    <Card onClick={() => openDrawer(String(client._id))} className={className}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium text-gray-700 min-w-0">
          <div className="flex items-center justify-center rounded-md bg-gray-50 p-1.5 flex-shrink-0">
            <BuildingIcon className="size-3.5 text-gray-400" />
          </div>
          <span className="truncate">{client.name}</span>
        </div>
        <ClientRolesBadge roles={client.roles} />
      </div>
    </Card>
  );
};
